import {
  cwayHomes,
  addresses,
  addToCart,
  removeItem,
  updateCart,
  addAddress,
  getProduct,
  getCartItem,
  getProducts,
  getProductsByCategory,
  orderProduct,
  getFavouites,
  removeAddress,
  unAuthenticatedUserCart,
  updateAuthenticatedCart,
  updateFavourite,
  getCategories as categories,
  removeItemUnAuthenticated as unAuthenciatedRemove,
  clearCartItem, clearUnAuthenticatedCartItem,
  getAdverts, getPopUpAdvert as fetchPopUpAdvert, removeFavourite, addCoupon, clearCoupon
} from "store/actions/business";
import { useSelector, useDispatch } from "react-redux";
import { useCallback } from "react";
import { saveFavorite, getFavorite, getCart } from "utils/helpers";
import { clearCart } from "utils/helpers";



export const useActivity = () => {
  // Store Hooks and Action Dispatch
  const dispatch = useDispatch();
  const state = useSelector(({ business }) => business);
  const stateAuth = useSelector((state) => state.auth);

  // Methods — useCallback so consumers can safely put these in useEffect deps
  const fetchProducts = useCallback(() => dispatch(getProducts()), [dispatch]);
  const fetchProductsByCategory = useCallback(
    (categoryId) => dispatch(getProductsByCategory(categoryId)),
    [dispatch],
  );

  const fetchProduct = useCallback((uuid) => dispatch(getProduct(uuid)), [dispatch]);

  const addItem = (value) => {
    dispatch(addToCart(value))
    console.log(state.cart)
  };

  const fetchCart = (value) => {

    dispatch(getCartItem(value))
  };

  const fetchFavourites = useCallback((data) => {
    console.log(data)
    dispatch(getFavouites(data ?? []))
  }, [dispatch])

  const addFav = (values) => {

    dispatch(
      updateFavourite(values)
    );

  };

  const getCwayHomes = useCallback(() => dispatch(cwayHomes()), [dispatch]);
  const adds = useCallback(() => dispatch(getAdverts()), [dispatch]);
  const getPopUpAdvert = useCallback(() => dispatch(fetchPopUpAdvert()), [dispatch]);
  const getAddress = useCallback(() => dispatch(addresses()), [dispatch]);

  const getCategories = useCallback(() => dispatch(categories()), [dispatch]);
  const clear = (id) => {

    if (state.cart?.length > 0) {
      if (stateAuth.isAuthenticated) {
        dispatch(clearCartItem(id))
      } else {
        clearCart()
        dispatch(clearUnAuthenticatedCartItem())
      }
    };
  }
  const update = (value) => {
    if (stateAuth.isAuthenticated) {
      dispatch(updateCart(value))
    } else {
      const cacheCart = getCart();
      // const findCart = cacheCart.find((data) => data?.product?.uuid === value?.product?.uuid);
      cacheCart.map((val) => {
        const key = val?.product?.id ?? val?.product?.uuid;
        const vKey = value?.product?.id ?? value?.product?.uuid;
        if (key != null && vKey != null && String(key) === String(vKey)) {
          val.quantity = value?.value
        }
        return val;
      })

      localStorage.setItem('cway:cart', JSON.stringify(cacheCart));
      dispatch(updateAuthenticatedCart(value))
    }
  }

  const getCoupon = (value) => dispatch(addCoupon(value))
  const resetCoupon = () => dispatch(clearCoupon())

  const removeCart = (value) => {
    if (stateAuth.isAuthenticated) {
      dispatch(removeItem(value))
    } else {
      dispatch(unAuthenciatedRemove(value))
    }

  };

  const deleteAddress = (id) => dispatch(removeAddress(id));

  const removeFav = (uuid) => dispatch(removeFavourite(uuid));

  const makeOrder = (value, id) => dispatch(orderProduct(value, id));

  const pushAddress = (value) => dispatch(addAddress(value));

  const addUnauthenticatedCart = (value, qnty) => dispatch(unAuthenticatedUserCart(value, qnty));

  return {
    state,
    update,
    addFav,
    addItem,
    fetchCart,
    makeOrder,
    removeCart,
    getAddress,
    pushAddress,
    getCwayHomes,
    addUnauthenticatedCart,
    fetchProduct,
    fetchProducts,
    fetchProductsByCategory,
    deleteAddress,
    getCategories,
    fetchFavourites,
    clear,
    adds,
    getPopUpAdvert,
    removeFav,
    getCoupon,
    resetCoupon
  };
};
